import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AntSwitch from "components/shared/switch/AntSwitch";

const IpvServer = ({
 description,
 enableIpv4,
 enableIpv6,
 setData
}: {
 description: string;
 enableIpv4: boolean;
 enableIpv6: boolean;
 setData: (section: string, value: string | number | boolean) => void;
}): ReactElement => {
 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="server.add.enableIp" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id={description} />
    </Typography>
    <Stack>
     <Stack justifyContent="center" alignContent="center" direction="column">
      <FormControlLabel
       sx={{ ml: 1 }}
       control={
        <AntSwitch checked={enableIpv4} onChange={(e) => setData("enableIpv4", e.target.checked)} />
       }
       label={
        <Typography ml={1}>
         <FormattedMessage id="server.add.enableIpv4" />
        </Typography>
       }
      />
     </Stack>
     <Stack justifyContent="center" alignContent="center" direction="column">
      <FormControlLabel
       sx={{ ml: 1 }}
       control={
        <AntSwitch checked={enableIpv6} onChange={(e) => setData("enableIpv6", e.target.checked)} />
       }
       label={
        <Typography ml={1}>
         <FormattedMessage id="server.add.enableIpv6" />
        </Typography>
       }
      />
     </Stack>
    </Stack>
   </Stack>
  </Paper>
 );
};

export default IpvServer;
